// Backend field errors may come from the structured widget contract or legacy
// agent validators. Keep paths visible rather than replacing them with success.
export function getConfigurationErrors(body) {
  const details = body?.error?.details || body?.errors || (Array.isArray(body?.error) ? body.error : []);
  if (!Array.isArray(details)) return {};
  return Object.fromEntries(details.map((entry, index) => {
    const path = entry?.path || entry?.loc || entry?.field || `configuration.${index + 1}`;
    const message = typeof entry === 'string' ? entry : entry?.message || entry?.msg || entry?.error_description || 'Invalid configuration.';
    return [Array.isArray(path) ? path.join('.') : String(path), message];
  }));
}
